import React from 'react'

type DynamicComponentProps = {
  as: React.ElementType
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

const DynamicHeadingTags = ({
  as: Element = 'h2',
  children,
  style,
  className,
}: DynamicComponentProps) => {
  return (
    <Element className={className} style={style}>
      {children}
    </Element>
  )
}

export default DynamicHeadingTags
